import { useEffect, useRef } from 'react';

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

// Generate or retrieve a session ID (persists across page navigations)
const getSessionId = () => {
  let sid = sessionStorage.getItem('pzv_session_id');
  if (!sid) {
    sid = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem('pzv_session_id', sid);
  }
  return sid;
};

export const trackEvent = (eventType, data = {}) => {
  const payload = {
    event_type: eventType,
    session_id: getSessionId(),
    ...data
  };
  // Fire-and-forget, non-blocking
  fetch(`${API_BASE}/tracking/view`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload)
  }).catch(() => {});
};

export const useTrackProductView = (productId) => {
  const tracked = useRef(false);
  useEffect(() => {
    if (productId && !tracked.current) {
      tracked.current = true;
      trackEvent('product_view', { product_id: String(productId) });
    }
  }, [productId]);
};

export const useTrackCategoryView = (categoryId) => {
  const tracked = useRef(null);
  useEffect(() => {
    if (categoryId && categoryId !== tracked.current) {
      tracked.current = categoryId;
      trackEvent('category_view', { category_id: Number(categoryId) });
    }
  }, [categoryId]);
};
